import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Card, Article } from '../common/Layout'
import SelectLocation from './SelectLocation'
import { getLocationIdParam } from '../../redux/modules/selectors'
import { loginRoute } from '../../routes/routes'
import { SimpleSpinner } from '../common/SimpleSpinner'
import { loadLocationsFromAddressIdStart } from '../../redux/modules/locationSearch'

export class SelectLocationPage extends Component {
  componentDidMount() {
    const { foundLocations } = this.props

    if ((!foundLocations || !foundLocations.length) && this.props.id) {
      this.props.loadLocationsFromAddressIdStart(this.props.id)
    }
  }
  render() {
    const {
      foundLocations,
      foundAddress,
      buildingName,
      id,
      isLocationLoading
    } = this.props
    if (!foundLocations || !foundLocations.length) {
      if (!id && !isLocationLoading) {
        window.location = loginRoute.path
        return null
      } else {
        return (
          <Article>
            <Card>
              <SimpleSpinner />
            </Card>
          </Article>
        )
      }
    } else {
      return (
        <Article>
          <Card>
            {
              <SelectLocation
                locations={foundLocations}
                address={foundAddress}
                buildingName={buildingName}
              />
            }
          </Card>
        </Article>
      )
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    foundLocations,
    foundAddress,
    buildingName,
    isLocationLoading
  } = state.locationSearch.locations
  return {
    id: getLocationIdParam(state, ownProps),
    foundLocations,
    foundAddress,
    buildingName,
    isLocationLoading
  }
}

const mapDispatchToProps = {
  loadLocationsFromAddressIdStart
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectLocationPage)
